var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPkr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2692C0 16.8177 2.53074 20.7748 6.26086 22.8101V1.72827C2.53074 3.76354 0 7.72068 0 12.2692Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 0.267334C9.92195 0.267334 7.96661 0.796225 6.26172 1.72641V22.8082C7.96661 23.7384 9.92195 24.2673 12.0009 24.2673C18.6282 24.2673 24.0009 18.8947 24.0009 12.2673C24.0009 5.63996 18.6282 0.267334 12.0009 0.267334Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1317 14.2538C15.6135 15.3507 13.4936 15.0092 12.3967 13.4911C11.2997 11.973 11.6412 9.85303 13.1593 8.75616C13.6327 8.41416 14.1645 8.21199 14.7056 8.14172C13.6647 7.98605 12.5643 8.22061 11.6438 8.88572C9.77534 10.2358 9.35501 12.8449 10.7051 14.7135C12.0551 16.5819 14.6643 17.0022 16.5328 15.652C17.4534 14.9869 18.0216 14.016 18.2005 12.9787C17.964 13.4702 17.6051 13.9117 17.1317 14.2538Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0669 8.09546L17.9221 9.01707L19.0628 8.48869L18.4505 9.58669L19.3056 10.5084L18.0721 10.2653L17.4598 11.3634L17.3097 10.1152L16.0762 9.87211L17.217 9.34374L17.0669 8.09546Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPkr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PKR.0c7d41aa0ba5b33671b56927c9297fb4.svg";